import { SIGNIN } from "./SecurityEvents";
import { Dispatcher } from "@aux4/dispatcher.js";

export function signIn() {
  Dispatcher.dispatch(SIGNIN);
}
